<template>
    <v-form
        ref="form">
        <v-row>
            <v-col cols="12" md="3" class="pe-1">
                <v-text-field
                    label="Code"
                    :value="form.code"
                    disabled
                    dense
                    outlined
                    hide-details
                    background-color="disabled">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3" class="pe-1">
                <PDatePicker
                    label="Date"
                    :rules="[isRequired]"
                    v-model="form.date"
                    hide
                    dense
                    outlined
                />
            </v-col>
            <v-col cols="12" md="3" class="pe-1">
                <v-autocomplete
                    label="Priority"
                    :rules="[isRequired]"
                    :items="priorities"
                    item-text="name"
                    item-value="id"
                    v-model="form.priority"
                    outlined
                    dense
                    hide-details="auto"
                >
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3" class="pe-1">
                <v-text-field
                    label="Receving Point"
                    :rules="[isRequired]"
                    v-model="form.receiving_point"
                    outlined
                    dense
                    hide-details="auto"
                >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <RequisitionFormLine 
                    v-for="(line, index) in form.lines"
                    :key="line.key"
                    v-model="form.lines[index]"
                    @delete:line="handleDeleteLine(index)"    
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-btn block depressed small @click="addLine">
                    <v-icon left>mdi-playlist-plus</v-icon>
                    add line                    
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-textarea
                    label="Notes"
                    v-model="form.notes"
                    outlined
                    hide-details="auto"
                >
                </v-textarea>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import { randomSix } from '../../utils/toolkit';
import RequisitionFormLine from './../../components/purchase/PurchaseRequisitionFormLine'
import { isRequired } from "../../utils/validations";
import PDatePicker from "./../common/PDatePicker";
export default {
    name: "RequistionForm",
    components: {
        PDatePicker,
        RequisitionFormLine
    },
    props: {
        value: Object,
        warehouseId: Number
    },
    data() {
        return {
            form: {
                code: '',
                date: '',
                priority: null,
                receiving_point:'',
                warehouse_id: this.warehouseId,
                lines: [],
                notes: ""
            },
            line: {
                item_id: null,
                quantity: null,
                measure_unit_id: null,
                description: ''
            }
        }
    },
    computed: {
        ...mapGetters({
            warehouses: "purchase/warehouse/list",
            priorities: "purchase/priority/list"
        })
    },  
    watch: {
        form: {
            deep: true,
            handler(form) {
                this.$emit("input", {...form})
            }
        }
        
    },
    methods: {
        isRequired,
        ...mapActions({
            searchWarehouses: "purchase/warehouse/search",
        }),
        addLine() {
            this.form.lines.push({ ...this.line, key: randomSix() });
        },
        handleDeleteLine(index) {
            this.form.lines.splice(index, 1)
        },
        submit() {
            if(!this.$refs.form.validate()) return;
            this.$emit("submit", this.form)
        },
        validate() {
            return this.$refs.form.validate()
        }
    },
    

    mounted() {
        this.value ? this.form = { ...this.form, ...this.value} : this.addLine(); 
    },
}
</script>

<style>

</style>